module.exports = __webpack_public_path__ + "static/media/delete-button.e1489a74.svg";